// removed by extract-text-webpack-plugin
module.exports = {"sidebarWidth":"242px","wolf":"#dcdee2","this":"AppLayoutContentView__this___2p8wz","sidebar":"AppLayoutContentView__sidebar___1fygg","sidebarScrollableArea":"AppLayoutContentView__sidebarScrollableArea___1nBfI"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/styles/AppLayoutContentView.css
// module id = 2738
// module chunks = 0 1